import React, { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import { logoutSucesso } from '../../redux/actions/autenticacaoAction';

class Logout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirecionar: false
        }
    }

    componentDidMount = async () => {
        try {
            delete axios.defaults.headers.common['Authorization'];
            localStorage.removeItem('@barriga/user');
            localStorage.removeItem('@barriga/token');
            this.setState({ redirecionar: true });
            this.props.logoutSucesso();
            this.props.exibirMensagem('yay', `Até Logo!`);
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        if (this.state.redirecionar) return <Redirect to="/login" />;
        return (<div></div>);
    }
}

Logout.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        logoutSucesso: () => dispatch(logoutSucesso()),
        exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/components/autenticacao/Logout.js